import React, {useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import Cookies from "js-cookie";
import { ESIGN_ENDPOINT} from "../configurations";


const useRequest = async (props) => {
    const authToken = Cookies.get('jwt');
    const {
        endPoint,
        method = "GET",
        body = null,
        responseFormat = 'json',
        returnStatus = false,
    } = props;

    try {

        const addBody = (body ? JSON.stringify(body) : null);

        const headers = {
            Authorization: `JWT ${authToken}`,
        };
        if (addBody) {
            headers['Content-Type'] = 'application/json';
        }

        const res = await fetch(ESIGN_ENDPOINT + endPoint, {
            method,
            body: addBody,
            headers,
        });

        const json = responseFormat === 'json'
            ? await res.json().catch(() => ({}))
            : null;

        if (returnStatus) {
            return { ok: res.ok, status: res.status, data: json };
        }

        if (res.ok) {
            if(responseFormat === 'json') {
                return json;
            }
            return res;
        }

        const msg = (json && json.message) ? json.message : 'Request failed';
        throw new Error(msg);
    } catch (error) {
        return Promise.reject(error);
    }
}

useRequest.propTypes = {
    endPoint: PropTypes.string.isRequired,
    method: PropTypes.string,
    body: PropTypes.object,
    responseFormat: PropTypes.string,
    returnStatus: PropTypes.bool,
};


export default useRequest;